import { Component, OnInit } from '@angular/core';
import Swal from 'sweetalert2';
import { ElementType } from '../../../enums/elements';
import { LeapmotorElementDTO } from '../../../models/elements-dto';
import { ElementService } from '../../../services/elements-service';
import { TrackingService } from '../../../services/tracking.service';
import { LogType } from '../../../enums/logtype';
import { visibleContentAnimation } from '../../../animations';

declare var $: any;
@Component({
  selector: 'app-carrusel',
  templateUrl: './carrusel.component.html',
  styleUrls: ['./carrusel.component.scss'],
  animations: [visibleContentAnimation],
})

export class CarruselComponent implements OnInit {
  data: LeapmotorElementDTO[] = [];
  type = ElementType.Carrusel;

  constructor(private elementService: ElementService, private trackingService: TrackingService) { }

  ngOnInit(): void {

    $('#carouselLeapmotor').carousel({
      interval: 5000
    });

    this.elementService.GetLeapmotorElementLst(this.type).subscribe(resp => {
      this.data = resp;
    }, (err) => {
      Swal.fire({
        icon: 'info',
        title: 'Cargando...',
        text: 'Espere por favor'
      });
    });

  }

  TrackCarrusel(id: string) {
    this.trackingService.trackElement(id, LogType.NavCarrusel).subscribe();
  }

}


